import { 
    AUTH_SUCCESS,
    AUTH_FAIL,
    REGISTER_SUCCESS,
    SIGNOUT_SUCCESS,
    EDIT,
    DELETE_SUCCESS,
    INIT_STATE
} from '../actionTypes';

import {auth,firestore,firebase} from '../../Firebase/firebaseConfig';

export const signOut=(history)=>dispatch=>{
    auth.signOut().then(()=> dispatch(signoutSuccess()))
    history.push("/register")
}

export const signoutSuccess=()=>({
    type : SIGNOUT_SUCCESS,
    payload : false
})


export const registerVendor=(formData,history,service)=>dispatch=>{
    firestore.collection('Services').doc(formData.service)
        .update({ data : firebase.firestore.FieldValue.arrayUnion(formData) })
        .then(()=>{
            dispatch(registerSuccess())
            setTimeout(() => {
                auth.signOut()
                history.push(`/`)                
            }, 4000);
        }
        )
        .catch(err=> console.log (err.code))
        
}


export const registerSuccess=()=>({
    type : REGISTER_SUCCESS,
    payload : false
})


export const EditVendor=(state,history)=>dispatch=>{
    firestore.collection('Services').doc(state.service)
        .update({ data : firebase.firestore.FieldValue.arrayUnion(state) })
        .then(()=>{
            dispatch(Editsuccess())
        }
        )
        .catch(err=> console.log (err.code))
        history.push('/')
}

export const Editsuccess=()=>({
    type : EDIT,
    payload : 'Edit Success'
})

export const deleteVendor=(state)=>dispatch=>{
    console.log(state)
    firestore.collection('Services').doc(state.service)
        .update({ data : firebase.firestore.FieldValue.arrayRemove(state) })
        .then(()=>{
            dispatch(deleteSuccess())
        }
        )
        .catch(err=> console.log (err.code))
}

export const deleteSuccess=()=>({
    type : DELETE_SUCCESS,
    payload : 'Deleted'
})



export const authAction=(email,password,history)=>dispatch=>{
    auth.signInWithEmailAndPassword(email,password)
    .then(credentials=>{
        dispatch(successAuth())
        setTimeout(() => {
            history.push('/register/vendorform')            
        }, 3000);
    }).catch(err=>{
        dispatch(failAuth(err.code))
    })
}

export const successAuth=()=>({
    type : AUTH_SUCCESS,
    payload : true
})


export const failAuth=(err_msg)=>({
    type : AUTH_FAIL,
    payload : err_msg
})


export const reducerInitial=()=>dispatch=>{
    dispatch(setToInitial())
}


export const setToInitial=()=>({
    type : INIT_STATE,
    payload : ""
})